var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-wrapper"},[_c('label',{staticClass:"label-text",attrs:{"id":_vm.labelId,"for":_vm.labelFor},domProps:{"textContent":_vm._s(_vm.text)}}),_vm._t("default",null,{"labelForId":_vm.labelFor})],2)}
var staticRenderFns = []

export { render, staticRenderFns }